import { createClient } from '@sanity/client'

const client = createClient({
  projectId: 'zmgq9jfb',
  dataset: 'production',
  apiVersion: '2022-01-12',
  useCdn: true,
  token: process.env.VUE_APP_SANITY_TOKEN,
})
const sanityPlugin = {
  install(Vue) {
    client.fetch('*[_type == "allBlogs"] | order(postedAt desc) {_id, blogTitle, slug{current}, thumbnail{asset->{url}}} [0...5]')
      .then(posts => {
        // eslint-disable-next-line no-param-reassign
        Vue.prototype.$posts = posts
      })
      .catch(
        this.handleError,
      )
  },
}
export default sanityPlugin
